import { render, staticRenderFns } from "./service-staff.vue?vue&type=template&id=752df3d5&scoped=true&"
import script from "./service-staff.vue?vue&type=script&lang=js&"
export * from "./service-staff.vue?vue&type=script&lang=js&"
import style0 from "./service-staff.vue?vue&type=style&index=0&id=752df3d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752df3d5",
  null
  
)

export default component.exports